import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Masonry from 'react-masonry-component';

import FotoFlatOffer from '../event/FotoFlatOffer';
import { PARTICIPANT } from '../../../utils/variables';

class MediaListMasonry extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobile: null,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.getSizes);
    this.getSizes();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.getSizes);
  }

  getSizes = () => {
    const windowWidth = window.innerWidth;

    //temporary fix for case when resizing happens when component is not yet mounted
    // revisit eventually
    if (!this.state) {
      return;
    }

    if (windowWidth >= 768) {
      this.setState({
        mobile: false,
      });
    } else {
      this.setState({
        mobile: true,
      });
    }
  };

  onImagesLoaded = imagesLoaded => {
    //we manually add classes to html elements to avoid a strange behavior with
    //this library which caused a memory leak when updating state in this method
    imagesLoaded.images.forEach(image => {
      if (!image.loaded && image.img && image.img.classList) {
        image.loaded = true;
        image.img.classList.add('image-loaded');
      }
    });
    this.containerElement.classList.add('show-fotoflat-offer');

    if (this.props.listType === PARTICIPANT && this.props.onImagesLoaded) {
      this.props.onImagesLoaded();
    }
  };

  getMasonryItems = () => {
    const {
      fotoFlatOffer,
      participantMediaCount,
      onBuyFotoFlatClick,
      impressionMediaCount,
      onScrollToImpressions,
      onScrollToVoucher,
    } = this.props;

    const { mobile } = this.state;

    if (fotoFlatOffer) {
      const targetIndex = this.state.mobile ? 4 : 3;

      return [
        ...this.props.children.slice(0, targetIndex),
        <FotoFlatOffer
          key="FotoFlatOffer"
          offer={fotoFlatOffer}
          mobile={mobile}
          participantMediaCount={participantMediaCount}
          impressionMediaCount={impressionMediaCount}
          onBuyFotoFlatClick={onBuyFotoFlatClick}
          onScrollToImpressions={onScrollToImpressions}
          onScrollToVoucher={onScrollToVoucher}
        />,
        ...this.props.children.slice(targetIndex),
      ];
    } else {
      return this.props.children;
    }
  };

  ref = element => {
    this.containerElement = element;
  };

  render() {
    return (
      <div className="medialist-container" ref={this.ref}>
        <div>
          <Masonry
            className="masonry-container"
            options={{
              columnWidth: '.medialist-item-container',
              gutter: 0,
              itemSelector: '.medialist-item-container',
              percentPosition: true,
            }}
            disableImagesLoaded={false}
            updateOnEachImageLoad={true}
            onImagesLoaded={this.onImagesLoaded}
          >
            {this.getMasonryItems()}
          </Masonry>
        </div>
      </div>
    );
  }
}

MediaListMasonry.propTypes = {
  participantMediaCount: PropTypes.number,
  impressionMediaCount: PropTypes.number,
  fotoFlatOffer: PropTypes.object,
  children: PropTypes.node,
  onBuyFotoFlatClick: PropTypes.func,
  onScrollToImpressions: PropTypes.func,
  onScrollToVoucher: PropTypes.func,
  onImagesLoaded: PropTypes.func,
  listType: PropTypes.string,
};

export default MediaListMasonry;
